/** Iglu Central schema for the W3C PerformanceNavigationTiming entry; `type` is the navigation type. */
export const NAVIGATION_TIMING_SCHEMA = 'iglu:org.w3/PerformanceNavigationTiming/jsonschema/1-0-0';

const NAVIGATION_TYPES = ['navigate', 'reload', 'back_forward', 'prerender'];

type NavigationContext = { data: { type: string }; schema: string };

/**
 * How the browser loaded the current document, as a Snowplow context for the initial page view.
 *
 * A reloaded or restored tab keeps the document referrer of its first load. A page first reached from
 * auth.motorway.co.uk is then reported as a new Referral session from auth hours later, without the
 * originSpId the Direct Transactional reattribution model needs. The navigation type lets the model
 * tell these reloads from real returns from auth.
 *
 * Only `type` is sent: the schema allows every other field to be omitted. Returns no context when the
 * Navigation Timing API is unavailable or reports an unknown type, so tracking is never blocked.
 */
export const getNavigationTypeContext = (): NavigationContext[] => {
  try {
    const [entry] = (globalThis.performance?.getEntriesByType?.('navigation') ?? []) as Array<{ type?: string }>;
    const type = entry?.type;

    return type && NAVIGATION_TYPES.includes(type) ? [{ data: { type }, schema: NAVIGATION_TIMING_SCHEMA }] : [];
  } catch {
    return [];
  }
};
